import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from 'clsx';
function _Status(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.587 6.585a2 2 0 0 1 2.828 2.828 6.03 6.03 0 0 0-2.828-2.828m-4.33-.328a6 6 0 0 1 1.258-2.242 8 8 0 1 0 8.47 8.47 6 6 0 0 1-2.242 1.258 6 6 0 1 1-7.486-7.486", clipRule: "evenodd" }), _jsx("circle", { cx: 16, cy: 8, r: 4, fill: "currentColor" })] }) });
}
const Status = forwardRef(_Status);
export { Status };
